<template>
	<div
		class="announcement-targets"
		@click="openSentTo"
		:class="{ clickable: canOpenSentTo }"
	>
		<ProfilePic :user="org" size="20px" v-if="withIcon && isOrgType" />
		<UserGroupIcon halo type="solid" v-if="withIcon && isGroupType" />
		<div class="target-name" v-text="targetName" />
		<div
			class="target-more"
			v-if="groupCount > 1"
			v-text="$t('common_plus_more', [groupCount - 1])"
		/>

		<AnnouncementSentToModal
			v-if="showSentToModal"
			:announcementId="announcement.id"
			@cancel="showSentToModal = false"
		/>
	</div>
</template>

<script>
import { ProfilePic } from '@/components/common'
import { UserGroupIcon } from '@/icons'
import { getChat, getOrganization } from '@/store'
import AnnouncementSentToModal from './AnnouncementSentToModal'

export default {
	name: 'AnnouncementTargets',
	components: { ProfilePic, UserGroupIcon, AnnouncementSentToModal },
	props: {
		announcement: Object,
		withIcon: { type: Boolean, default: null },
		showSentTo: { type: Boolean, default: null },
		orgCount: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return { org: getOrganization(), showSentToModal: false }
	},
	computed: {
		targets() {
			return this.announcement.targets || {}
		},
		isOrgType() {
			return !!this.targets.organization_id
		},
		isGroupType() {
			return !!this.targets.bubble_ids
		},
		groupCount() {
			return this.targets.bubble_ids?.length ?? 0
		},
		targetName() {
			if (this.isOrgType) {
				if (!this.orgCount > 0) return this.org.name
				const orgCount = this.$t(
					'announcements_targetcount.variable',
					[this.orgCount],
					this.orgCount
				)
				return `${this.org.name} ${orgCount}`
			}
			if (this.isGroupType) {
				const chat = this.targets.bubble_ids
					.map(getChat)
					.filter((c) => c.id)
					.at(0)
				return chat ? chat.displayname : this.$t('announcements_no_groups')
			}
			return null
		},
		canOpenSentTo() {
			if (!this.showSentTo) return false
			if (this.isGroupType) {
				const chats = this.targets.bubble_ids.map(getChat).filter((c) => c.id)
				return chats.length > 0
			}
			return false
		},
	},
	methods: {
		openSentTo() {
			if (!this.canOpenSentTo) return false
			this.showSentToModal = true
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.announcement-targets {
	max-width: 100%;
	@include flex(8px);
	flex-wrap: nowrap;

	&.clickable {
		cursor: pointer;
	}

	.pronto-icon {
		color: var(--blue-300);
		font-size: 12px;
	}
	.target-name {
		@include ellipsis;
		font-size: 16px;
	}
	.target-more {
		@include fontFamily(900);
		color: var(--blue-300);
		white-space: nowrap;
		flex-shrink: 0;
	}
}
</style>
